Drupal.behaviors.view_forms = {
  attach: function (context, settings) {

    let addEventViewsForms = function (event) {
      document.querySelectorAll('.views-exposed-form').forEach(form => {
        let resetIcon = form.querySelector('.reset-icon');
        resetIcon.addEventListener('click', event => {

          form.reset();

          form.querySelectorAll('input:not([type="submit"], textarea)').forEach(field => {
            field.value = '';
          });
          form.querySelectorAll('select').forEach(field => {
            console.log(field);
            field.selectedIndex = 0;
          });

          let resetBtn = form.querySelector('.btn-reset');
          resetBtn.click();
        })
      })
    }

    function addEvent(parent, evt, selector, handler) {
      parent.addEventListener(evt, function(event) {
        if (event.target.matches(selector + ', ' + selector + ' *')) {
          handler.apply(event.target.closest(selector), arguments);
        }
      }, false);
    }

    /* To be used as */

    addEvent(document, 'click', '[data-select-item]', function(e) {
      e.preventDefault();
      let dataVal = this.dataset.selectItem;
      let parentID = this.closest('[data-bef-fake]').dataset.befFake;
      let $form = this.closest('form');
      let $select = document.querySelector(`[data-bef-select="${parentID}"]`);

      console.log(parentID, $select)

      document.querySelectorAll('[data-select-item]').forEach(elem => {
        elem.classList.remove('bef-link--selected');
      })

      this.classList.add('bef-link--selected');
      $select.value = dataVal;

      $select.dispatchEvent(new Event('change'));
      $form.querySelector('.btn-primary').dispatchEvent(new Event('click'));
    });

    addEventViewsForms();
  }
};
